export const translations = {
  'zh-TW': {
    nav: {
      home: '首頁',
      about: '關於我們',
      products: '旗艦平台',
      contact: '聯繫我們',
      blog: '技術洞察',
    },
    lang: {
      'zh-TW': '繁體中文',
      'zh-CN': '简体中文',
      en: 'English',
    },
    home: {
      hero_title_l1: '自主合約風險智能',
      hero_title_l2: '與合規掃描引擎',
      hero_subtitle_l1: 'Vowpace 在你簽約前審查美國商業分包合約中的風險條款；LC Shield 預先核對信用證單據（通常 30 秒內）。',
      hero_subtitle_l2: '把艱澀的合約條文與國際規則，變成企業可信賴的即時風控引擎。',
      hero_cta: '探索旗艦平台',
      hero_cta2: '預約企業諮詢',
      sim_title: '即時風險審核',
      sim_doc: '合約文件解析中',
      sim_r1: '違約賠償金條款 §8.7',
      sim_r1_tag: '高風險',
      sim_r2: '發票與提單幣別不一致',
      sim_r2_tag: '需跟進',
      sim_r3: 'UCP 600 第 14 條核對',
      sim_r3_tag: '已通過',
      sim_r4: 'MT700 欄位 45A 貨物描述比對',
      sim_r4_tag: '已通過',
      sim_r5: 'Pay-if-paid 條款 §9.3',
      sim_r5_tag: '高風險',
      sim_r6: '未設上限違約賠償金 §12.2',
      sim_r6_tag: '危急',
      sim_stream: '即時合約串流',
      sim_flags: '即時風險標記',
      sim_score: '合規評分',
      sim_done: '分析完成 · 文件不儲存於伺服器',
      m1_v: '2', m1_l: '旗艦企業平台',
      m2_v: '即時', m2_l: '記憶體內文件處理',
      m3_v: '≈30s', m3_l: 'LC Shield 預審（通常 30 秒內）',
      m4_v: '全球', m4_l: '跨境合規覆蓋',
      flagship_label: '旗艦平台',
      flagship_title: '兩大引擎，守護每一份關鍵文件',
      trust_label: '為何信任 DZent',
      trust_title: '以架構與規則建立的信任',
      pillar1_t: '私隱優先架構',
      pillar1_d: 'LC Shield：上傳文件僅在記憶體中處理，分析後不會儲存於我們的伺服器，亦不用於訓練模型。Vowpace 會在您的帳戶存續期間儲存經遮蔽處理的合約文字。',
      pillar2_t: '規則級精準引擎',
      pillar2_d: '規則對照結果：每項發現均註明其所依據的 UCP 600 或 ISBP 821 (2023) 條文。結果由 AI 輔助產生，不能取代銀行的審單。',
      pillar3_t: '香港打造',
      pillar3_d: '立足香港。本網站提供英文、繁體中文及简体中文版本；LC Shield 目前僅提供英文介面。',
      cta_band_t: '準備好為你的合約把關了嗎？',
      cta_band_d: '與我們的團隊談談，了解 Vowpace AI 與 LC Shield 如何融入你的工作流程。',
      cta_band_btn: '聯絡我們',
      philosophy_label: '我們的理念',
      philosophy: '埵智堅信，優秀的產品本身就是最好的名片。我們只專注於打造我們自己也熱愛使用的應用。',
      advantages_label: '核心優勢',
      adv_user_title: '以用戶為中心',
      adv_user_desc: '深入理解用戶需求，打造真正有用的產品。',
      adv_design_title: '設計驅動',
      adv_design_desc: '追求簡潔、美觀、直觀的用戶界面與體驗。',
      adv_tech_title: '技術領先',
      adv_tech_desc: '採用前沿技術，確保產品穩定、流暢、安全。',
      adv_craft_title: '精益求精',
      adv_craft_desc: '持續迭代，用心打磨每一個細節。',
      featured_label: '精選產品',
      featured_cta: '了解更多',
      mp_label: '孵化企劃',
      insights_label: '技術洞察',
      insights_view_all: '查看全部洞察',
      mp_name: '情抒',
      mp_tagline: 'A Letter to Your Future Self',
      mp_desc: '寫一封信給未來的自己。將今天封存 90、180 或 365 天，在你早已遺忘的某個午夜，它會連同一位「老朋友」的溫柔回信，悄悄回到你的信箱。沒有 AI 說教，只有時間的浪漫。',
      mp_letter_to: '致：未來的自己',
      mp_letter_line: '今晚，把心事交給時間。',
      mp_letter_sign: '情抒 · 365 夜',
    },
    insights: {
      label: 'DZent Insights',
      title: '技術洞察',
      subtitle: '從貿易金融合規、建築合約風險到私隱優先架構 — 我們把打造兩大旗艦風控平台的工程思考，寫成可供業界參考的深度筆記。',
      chip1: '貿易金融合規',
      chip2: '建築科技',
      chip3: '私隱架構',
      featured: '精選文章',
      all: '全部文章',
      read: '閱讀全文',
    },
    about: {
      title: '關於我們',
      story_label: '公司故事',
      story: '埵智有限公司（DZent Limited）是一間立足香港的垂直領域 AI 企業，專注於「合約風險掃描與管理」。我們相信，企業最大的隱形成本埋藏在合約與單據的條文之間 — 因此我們打造了兩大旗艦平台：專為美國商業分包商而設的簽約前分包合約條款風險審查的 Vowpace AI，以及依 UCP 600 與 ISBP 821 (2023) 規則預先核對信用證單據（通常 30 秒內）的 LC Shield。',
      story2: '我們不是通用 AI 公司，而是把單一領域做到極致的專家：把艱澀的國際規則轉譯成可稽核的審核引擎，把數百頁合約化為動態責任時間軸，同時堅守私隱優先架構 — LC Shield 上傳文件分析後不儲存於伺服器；Vowpace 僅儲存經遮蔽處理的合約文字。我們立足香港，以三種語言發佈本網站；各產品的語言支援詳見其產品頁面。',
      vision_label: '願景',
      vision: '成為全球企業最信賴的合約風險智能夥伴，讓每一份合約在簽署前被徹底看清。',
      mission_label: '使命',
      mission: '以規則級精準引擎與私隱優先架構，為建築與貿易金融行業降低合約與單據風險。',
      values_label: '核心價值',
      value_user: '領域深度',
      value_innovation: '規則級精準',
      value_excellence: '私隱優先',
      value_collaboration: '全球視野',
      eco_caption: 'DZent 旗艦平台',
      eco_vowpace_tag: 'B2B 企業建築 AI',
      eco_lc_tag: 'B2B 貿易金融',
      eco_miprose_tag: 'B2C 網頁生活平台',
      eco_coach_tag: 'B2C 行動應用',
      metrics_label: '企業關鍵指標',
      metric_products: '旗艦企業平台',
      metric_privacy: '傳輸加密（HTTPS）',
      metric_langs: 'LC Shield 預審（通常 30 秒內）',
      metric_global_value: '跨境',
      metric_global: '合規與佈局',
      bento1_t: '企業合約與合規引擎',
      bento1_d: '單一引擎同時理解建築合約與貿易單據：逐條解析、依 UCP 600 / ISBP 821 (2023) 規則與美國分包合約條款交叉核對，輸出可稽核的風險報告。',
      bento1_scan: '條款掃描中',
      bento2_t: '私隱優先架構',
      bento2_d: 'LC Shield：上傳文件僅在記憶體中處理，分析後不會儲存於我們的伺服器。Vowpace 會在您的帳戶存續期間儲存經遮蔽處理的合約文字 — 傳輸加密（HTTPS）。',
      bento3_t: '簽約前條款風險審查',
      bento3_d: 'Vowpace 在簽署前標記美國分包合約中的違約賠償金、彌償與有條件付款條款，每項發現均註明條款出處。',
      terminal_label: '信任與合規終端',
      terminal_note: '所有審核依據行業規則庫即時執行。LC Shield：上傳文件分析後不儲存於伺服器；Vowpace：帳戶存續期間儲存經遮蔽處理的合約文字。',
      expertise_label: '我們的專長',
      exp1_title: '合約風險掃描',
      exp1_desc: '自動標記美國分包合約中的違約賠償金、彌償與有條件付款（pay-if-paid）條款。',
      exp2_title: '合規智能',
      exp2_desc: '把 UCP 600、ISBP 821 (2023) 等艱澀行業規則，轉譯成即時運作的 AI 審核引擎。',
      exp3_title: '私隱優先架構',
      exp3_desc: 'LC Shield：上傳文件分析後不儲存於伺服器。Vowpace 會在帳戶存續期間儲存經遮蔽處理的合約文字。',
      exp4_title: '美國分包合約審查',
      exp4_desc: '在簽署前標記美國分包合約中的高風險條款 — 違約賠償金、彌償與付款條件。',
      timeline_label: '公司歷程',
      tl1_year: '2026',
      tl1_title: '於香港成立',
      tl1_desc: 'DZent 於香港正式成立，確立「合約風險掃描與管理」垂直定位，推出雙旗艦平台：建築合約風控 Vowpace AI 與信用證預審 LC Shield。',
      tl2_year: '2026 下半年',
      tl2_title: '企業級生態深化',
      tl2_desc: '全面擴展 B2B 合規與金融 AI 市場，深化跨國貿易與營造合約風控解決方案，對接更多企業客戶。',
      tl3_year: '未來',
      tl3_title: '未來發展',
      tl3_desc: '持續深化合約智能與合規審核技術，把香港 AI 工作室的專業帶到更多市場。',
      cta_title: '想為你的企業把關每一份合約？',
      cta_desc: '無論是企業合作、平台演示或媒體訪問，我們都樂意聆聽。',
      cta_btn: '聯絡我們',
    },
    products: {
      title: '旗艦平台',
      subtitle: '專注合約風險掃描與管理的兩大企業級引擎',
      learn_more: '了解更多',
      launch_app: '啟動應用',
      coming_soon: '即將推出',
      coming_soon_desc: '更多精彩產品正在開發中，敬請期待。',
      mp_name: '情抒',
      mp_desc: '寫一封信給未來的自己 — 封存 90 至 365 天的時間膠囊網頁體驗，於午夜送回你的信箱。',
      vw_tagline: '專為美國商業分包商而設的簽約前分包合約條款風險審查',
      vw_desc: '專為美國商業分包商而設的簽約前分包合約條款風險審查 — 自動標記隱藏的違約賠償金、概括性彌償與有條件付款（pay-when-paid）條款。',
      lc_tagline: 'AI 驅動的 UCP 600 與 MT700 單據瑕疵審核助手',
      lc_desc: '在交單予銀行之前，依 UCP 600 與 ISBP 821 (2023) 預先核對您的信用證交單文件 — 通常 30 秒內完成，助您及早發現可能的瑕疵。',
      visit_site: '造訪網站',
      explore: '探索',
      lc_cta: '造訪 getlcshield.com',
    },
    product_detail: {
      download: '下載 App',
      download_ios: 'App Store',
      download_android: 'Google Play',
      coming_soon_badge: '即將上架',
      features_title: '核心功能',
      screenshots_title: 'App 截圖',
      design_title: '設計理念',
      download_title: '立即下載',
    },
    contact: {
      title: '聯繫我們',
      subtitle: '有任何問題或合作意向？歡迎隨時與我們聯繫。',
      name: '姓名',
      name_placeholder: '請輸入您的姓名',
      email: '電子郵箱',
      email_placeholder: '請輸入您的電子郵箱',
      message: '留言內容',
      message_placeholder: '請輸入您的留言內容',
      submit: '發送',
      sending: '發送中...',
      success: '感謝您的留言！我們會盡快回覆您。',
      error: '發送失敗，請稍後再試。',
      email_label: '公司郵箱',
      validation_name: '請輸入姓名',
      validation_email: '請輸入有效的電子郵箱',
      validation_message: '請輸入留言內容',
      company_label: '公司資料',
      company_name: '埵智有限公司 DZent Limited',
      company_registered: '於香港註冊成立的有限公司',
    },
    footer: {
      copyright: '© 2026 埵智有限公司 (DZent Limited). 版權所有。',
      email: 'info@dzentlimited.com',
      follow_us: '關注我們',
      company_name: '埵智有限公司 DZent Limited',
      registered: '於香港註冊成立的有限公司',
      legal_label: '法律條款',
      privacy: '私隱政策',
      terms: '服務條款',
    },
  },
  'zh-CN': {
    nav: {
      home: '首页',
      about: '关于我们',
      products: '旗舰平台',
      contact: '联系我们',
      blog: '技术洞察',
    },
    lang: {
      'zh-TW': '繁體中文',
      'zh-CN': '简体中文',
      en: 'English',
    },
    home: {
      hero_title_l1: '自主合同风险智能',
      hero_title_l2: '与合规扫描引擎',
      hero_subtitle_l1: 'Vowpace 在你签约前审查美国商业分包合同中的风险条款；LC Shield 预先核对信用证单据（通常 30 秒内）。',
      hero_subtitle_l2: '把艰涩的合同条文与国际规则，变成企业可信赖的即时风控引擎。',
      hero_cta: '探索旗舰平台',
      hero_cta2: '预约企业咨询',
      sim_title: '即时风险审核',
      sim_doc: '合同文件解析中',
      sim_r1: '违约赔偿金条款 §8.7',
      sim_r1_tag: '高风险',
      sim_r2: '发票与提单币别不一致',
      sim_r2_tag: '需跟进',
      sim_r3: 'UCP 600 第 14 条核对',
      sim_r3_tag: '已通过',
      sim_r4: 'MT700 栏位 45A 货物描述比对',
      sim_r4_tag: '已通过',
      sim_r5: 'Pay-if-paid 条款 §9.3',
      sim_r5_tag: '高风险',
      sim_r6: '未设上限违约赔偿金 §12.2',
      sim_r6_tag: '危急',
      sim_stream: '实时合同流',
      sim_flags: '实时风险标记',
      sim_score: '合规评分',
      sim_done: '分析完成 · 文件不存储于服务器',
      m1_v: '2', m1_l: '旗舰企业平台',
      m2_v: '即时', m2_l: '内存内文件处理',
      m3_v: '≈30s', m3_l: 'LC Shield 预审（通常 30 秒内）',
      m4_v: '全球', m4_l: '跨境合规覆盖',
      flagship_label: '旗舰平台',
      flagship_title: '两大引擎，守护每一份关键文件',
      trust_label: '为何信任 DZent',
      trust_title: '以架构与规则建立的信任',
      pillar1_t: '隐私优先架构',
      pillar1_d: 'LC Shield：上传文件仅在内存中处理，分析后不会存储于我们的服务器，亦不用于训练模型。Vowpace 会在您的账户存续期间存储经脱敏处理的合同文本。',
      pillar2_t: '规则级精准引擎',
      pillar2_d: '规则对照结果：每项发现均注明其所依据的 UCP 600 或 ISBP 821 (2023) 条文。结果由 AI 辅助产生，不能取代银行的审单。',
      pillar3_t: '香港打造',
      pillar3_d: '立足香港。本网站提供英文、繁體中文及简体中文版本；LC Shield 目前仅提供英文界面。',
      cta_band_t: '准备好为你的合同把关了吗？',
      cta_band_d: '与我们的团队谈谈，了解 Vowpace AI 与 LC Shield 如何融入你的工作流程。',
      cta_band_btn: '联系我们',
      philosophy_label: '我们的理念',
      philosophy: '埵智坚信，优秀的产品本身就是最好的名片。我们只专注于打造我们自己也热爱使用的应用。',
      advantages_label: '核心优势',
      adv_user_title: '以用户为中心',
      adv_user_desc: '深入理解用户需求，打造真正有用的产品。',
      adv_design_title: '设计驱动',
      adv_design_desc: '追求简洁、美观、直观的用户界面与体验。',
      adv_tech_title: '技术领先',
      adv_tech_desc: '采用前沿技术，确保产品稳定、流畅、安全。',
      adv_craft_title: '精益求精',
      adv_craft_desc: '持续迭代，用心打磨每一个细节。',
      featured_label: '精选产品',
      featured_cta: '了解更多',
      mp_label: '孵化企划',
      insights_label: '技术洞察',
      insights_view_all: '查看全部洞察',
      mp_name: '情抒',
      mp_tagline: 'A Letter to Your Future Self',
      mp_desc: '写一封信给未来的自己。将今天封存 90、180 或 365 天，在你早已遗忘的某个午夜，它会连同一位「老朋友」的温柔回信，悄悄回到你的信箱。没有 AI 说教，只有时间的浪漫。',
      mp_letter_to: '致：未来的自己',
      mp_letter_line: '今晚，把心事交给时间。',
      mp_letter_sign: '情抒 · 365 夜',
    },
    insights: {
      label: 'DZent Insights',
      title: '技术洞察',
      subtitle: '从贸易金融合规、建筑合同风险到隐私优先架构 — 我们把打造两大旗舰风控平台的工程思考，写成可供业界参考的深度笔记。',
      chip1: '贸易金融合规',
      chip2: '建筑科技',
      chip3: '隐私架构',
      featured: '精选文章',
      all: '全部文章',
      read: '阅读全文',
    },
    about: {
      title: '关于我们',
      story_label: '公司故事',
      story: '埵智有限公司（DZent Limited）是一间立足香港的垂直领域 AI 企业，专注于「合同风险扫描与管理」。我们相信，企业最大的隐形成本埋藏在合同与单据的条文之间 — 因此我们打造了两大旗舰平台：专为美国商业分包商而设的签约前分包合同条款风险审查的 Vowpace AI，以及依 UCP 600 与 ISBP 821 (2023) 规则预先核对信用证单据（通常 30 秒内）的 LC Shield。',
      story2: '我们不是通用 AI 公司，而是把单一领域做到极致的专家：把艰涩的国际规则转译成可审计的审核引擎，把数百页合同化为动态责任时间轴，同时坚守隐私优先架构 — LC Shield 上传文件分析后不存储于服务器；Vowpace 仅存储经脱敏处理的合同文本。我们立足香港，以三种语言发布本网站；各产品的语言支持详见其产品页面。',
      vision_label: '愿景',
      vision: '成为全球企业最信赖的合同风险智能伙伴，让每一份合同在签署前被彻底看清。',
      mission_label: '使命',
      mission: '以规则级精准引擎与隐私优先架构，为建筑与贸易金融行业降低合同与单据风险。',
      values_label: '核心价值',
      value_user: '领域深度',
      value_innovation: '规则级精准',
      value_excellence: '隐私优先',
      value_collaboration: '全球视野',
      eco_caption: 'DZent 旗舰平台',
      eco_vowpace_tag: 'B2B 企业建筑 AI',
      eco_lc_tag: 'B2B 贸易金融',
      eco_miprose_tag: 'B2C 网页生活平台',
      eco_coach_tag: 'B2C 移动应用',
      metrics_label: '企业关键指标',
      metric_products: '旗舰企业平台',
      metric_privacy: '传输加密（HTTPS）',
      metric_langs: 'LC Shield 预审（通常 30 秒内）',
      metric_global_value: '跨境',
      metric_global: '合规与布局',
      bento1_t: '企业合同与合规引擎',
      bento1_d: '单一引擎同时理解建筑合同与贸易单据：逐条解析、依 UCP 600 / ISBP 821 (2023) 规则与美国分包合同条款交叉核对，输出可审计的风险报告。',
      bento1_scan: '条款扫描中',
      bento2_t: '隐私优先架构',
      bento2_d: 'LC Shield：上传文件仅在内存中处理，分析后不会存储于我们的服务器。Vowpace 会在您的账户存续期间存储经脱敏处理的合同文本 — 传输加密（HTTPS）。',
      bento3_t: '签约前条款风险审查',
      bento3_d: 'Vowpace 在签署前标记美国分包合同中的违约赔偿金、弥偿与有条件付款条款，每项发现均注明条款出处。',
      terminal_label: '信任与合规终端',
      terminal_note: '所有审核依据行业规则库即时执行。LC Shield：上传文件分析后不存储于服务器；Vowpace：账户存续期间存储经脱敏处理的合同文本。',
      expertise_label: '我们的专长',
      exp1_title: '合同风险扫描',
      exp1_desc: '自动标记美国分包合同中的违约赔偿金、弥偿与有条件付款（pay-if-paid）条款。',
      exp2_title: '合规智能',
      exp2_desc: '把 UCP 600、ISBP 821 (2023) 等艰涩行业规则，转译成实时运作的 AI 审核引擎。',
      exp3_title: '隐私优先架构',
      exp3_desc: 'LC Shield：上传文件分析后不存储于服务器。Vowpace 会在账户存续期间存储经脱敏处理的合同文本。',
      exp4_title: '美国分包合同审查',
      exp4_desc: '在签署前标记美国分包合同中的高风险条款 — 违约赔偿金、弥偿与付款条件。',
      timeline_label: '公司历程',
      tl1_year: '2026',
      tl1_title: '于香港成立',
      tl1_desc: 'DZent 于香港正式成立，确立「合同风险扫描与管理」垂直定位，推出双旗舰平台：建筑合同风控 Vowpace AI 与信用证预审 LC Shield。',
      tl2_year: '2026 下半年',
      tl2_title: '企业级生态深化',
      tl2_desc: '全面扩展 B2B 合规与金融 AI 市场，深化跨国贸易与建造合同风控解决方案，对接更多企业客户。',
      tl3_year: '未来',
      tl3_title: '未来发展',
      tl3_desc: '持续深化合同智能与合规审核技术，把香港 AI 工作室的专业带到更多市场。',
      cta_title: '想为你的企业把关每一份合同？',
      cta_desc: '无论是企业合作、平台演示或媒体访问，我们都乐意聆听。',
      cta_btn: '联系我们',
    },
    products: {
      title: '旗舰平台',
      subtitle: '专注合同风险扫描与管理的两大企业级引擎',
      learn_more: '了解更多',
      launch_app: '启动应用',
      coming_soon: '即将推出',
      coming_soon_desc: '更多精彩产品正在开发中，敬请期待。',
      mp_name: '情抒',
      mp_desc: '写一封信给未来的自己 — 封存 90 至 365 天的时间胶囊网页体验，于午夜送回你的信箱。',
      vw_tagline: '专为美国商业分包商而设的签约前分包合同条款风险审查',
      vw_desc: '专为美国商业分包商而设的签约前分包合同条款风险审查 — 自动标记隐藏的违约赔偿金、概括性弥偿与有条件付款（pay-when-paid）条款。',
      lc_tagline: 'AI 驱动的 UCP 600 与 MT700 单据瑕疵审核助手',
      lc_desc: '在交单予银行之前，依 UCP 600 与 ISBP 821 (2023) 预先核对您的信用证交单文件 — 通常 30 秒内完成，助您及早发现可能的瑕疵。',
      visit_site: '造访网站',
      explore: '探索',
      lc_cta: '造访 getlcshield.com',
    },
    product_detail: {
      download: '下载 App',
      download_ios: 'App Store',
      download_android: 'Google Play',
      coming_soon_badge: '即将上架',
      features_title: '核心功能',
      screenshots_title: 'App 截图',
      design_title: '设计理念',
      download_title: '立即下载',
    },
    contact: {
      title: '联系我们',
      subtitle: '有任何问题或合作意向？欢迎随时与我们联系。',
      name: '姓名',
      name_placeholder: '请输入您的姓名',
      email: '电子邮箱',
      email_placeholder: '请输入您的电子邮箱',
      message: '留言内容',
      message_placeholder: '请输入您的留言内容',
      submit: '发送',
      sending: '发送中...',
      success: '感谢您的留言！我们会尽快回复您。',
      error: '发送失败，请稍后再试。',
      email_label: '公司邮箱',
      validation_name: '请输入姓名',
      validation_email: '请输入有效的电子邮箱',
      validation_message: '请输入留言内容',
      company_label: '公司资料',
      company_name: '埵智有限公司 DZent Limited',
      company_registered: '于香港注册成立的有限公司',
    },
    footer: {
      copyright: '© 2026 埵智有限公司 (DZent Limited). 版权所有。',
      email: 'info@dzentlimited.com',
      follow_us: '关注我们',
      company_name: '埵智有限公司 DZent Limited',
      registered: '于香港注册成立的有限公司',
      legal_label: '法律条款',
      privacy: '隐私政策',
      terms: '服务条款',
    },
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      products: 'Products',
      contact: 'Contact',
      blog: 'Insights',
    },
    lang: {
      'zh-TW': '繁體中文',
      'zh-CN': '简体中文',
      en: 'English',
    },
    home: {
      hero_title_l1: 'Autonomous Contract Risk Intelligence',
      hero_title_l2: '& Compliance Scanning',
      hero_subtitle_l1: 'Vowpace reviews US commercial subcontracts for risky clauses before you sign; LC Shield pre-checks LC documents, typically under 30 seconds.',
      hero_subtitle_l2: 'Turning dense contract clauses and international rules into a real-time risk engine enterprises can trust.',
      hero_cta: 'Explore Flagship Platforms',
      hero_cta2: 'Book a Consultation',
      sim_title: 'Live Risk Audit',
      sim_doc: 'Parsing contract document',
      sim_r1: 'Liquidated damages clause §8.7',
      sim_r1_tag: 'High Risk',
      sim_r2: 'Invoice / B/L currency mismatch',
      sim_r2_tag: 'Follow Up',
      sim_r3: 'UCP 600 Art. 14 check',
      sim_r3_tag: 'Passed',
      sim_r4: 'MT700 Field 45A goods match',
      sim_r4_tag: 'Passed',
      sim_r5: 'Pay-if-paid clause §9.3',
      sim_r5_tag: 'High Risk',
      sim_r6: 'Uncapped LD clause §12.2',
      sim_r6_tag: 'Critical',
      sim_stream: 'Live Contract Stream',
      sim_flags: 'Real-time Risk Flags',
      sim_score: 'Compliance Score',
      sim_done: 'Analysis complete · Documents not saved to our servers',
      m1_v: '2', m1_l: 'Flagship Enterprise Platforms',
      m2_v: 'Live', m2_l: 'In-Memory Processing',
      m3_v: '≈30s', m3_l: 'LC Shield pre-check (typically under 30s)',
      m4_v: 'Global', m4_l: 'Cross-Border Compliance',
      flagship_label: 'Flagship Platforms',
      flagship_title: 'Two engines guarding every critical document',
      trust_label: 'Why Trust DZent',
      trust_title: 'Trust built on architecture and rules',
      pillar1_t: 'Privacy-First Architecture',
      pillar1_d: 'LC Shield: uploaded documents are processed in memory and are not saved to our servers after analysis, nor used for training. Vowpace stores redacted contract text for the life of your account.',
      pillar2_t: 'Rule-Grade Precision Engines',
      pillar2_d: "Rule-referenced results: every finding cites the UCP 600 or ISBP 821 (2023) article it relies on. Results are AI-assisted and are not a substitute for your bank's examination.",
      pillar3_t: 'Built in Hong Kong',
      pillar3_d: 'Based in Hong Kong. This website is available in English, 繁體中文 and 简体中文; LC Shield is currently English-only.',
      cta_band_t: 'Ready to safeguard your contracts?',
      cta_band_d: 'Talk to our team about how Vowpace AI and LC Shield fit into your workflow.',
      cta_band_btn: 'Contact Us',
      philosophy_label: 'Our Philosophy',
      philosophy: 'DZent believes that great products are the best business cards. We focus solely on building apps that we ourselves love to use.',
      advantages_label: 'Core Strengths',
      adv_user_title: 'User-Centric',
      adv_user_desc: 'Deep understanding of user needs to build truly useful products.',
      adv_design_title: 'Design-Driven',
      adv_design_desc: 'Pursuing clean, beautiful, and intuitive UI/UX.',
      adv_tech_title: 'Tech-Forward',
      adv_tech_desc: 'Leveraging cutting-edge technology for stable, smooth, and secure products.',
      adv_craft_title: 'Craftsmanship',
      adv_craft_desc: 'Continuous iteration, meticulously refining every detail.',
      featured_label: 'Featured Product',
      featured_cta: 'Learn More',
      mp_label: 'Incubated Project',
      insights_label: 'Tech Insights',
      insights_view_all: 'View All Insights',
      mp_name: 'MiProse',
      mp_tagline: 'A Letter to Your Future Self',
      mp_desc: "Write a letter to your future self. Seal it for 90, 180, or 365 days — and on a midnight you least expect, it returns to your inbox with a quiet reply from an old friend. No AI lectures, just the romance of time.",
      mp_letter_to: 'To: your future self',
      mp_letter_line: 'Tonight, leave it all to time.',
      mp_letter_sign: 'MiProse · 365 nights',
    },
    insights: {
      label: 'DZent Insights',
      title: 'Tech Insights',
      subtitle: 'From trade finance compliance and construction contract risk to privacy-first architecture — deep engineering notes from building our flagship contract-risk platforms.',
      chip1: 'Trade Finance Compliance',
      chip2: 'Construction Tech',
      chip3: 'Privacy Architecture',
      featured: 'Featured',
      all: 'All Articles',
      read: 'Read Article',
    },
    about: {
      title: 'About Us',
      story_label: 'Our Story',
      story: 'DZent Limited is a Hong Kong-based vertical AI enterprise dedicated to contract risk scanning and management. We believe an enterprise\'s largest hidden costs are buried inside contract and document clauses — so we built two flagship platforms: Vowpace AI, a pre-signature subcontract clause-risk review for US commercial subcontractors, and LC Shield, which pre-checks letter-of-credit documents against UCP 600 and ISBP 821 (2023) rules, typically under 30 seconds.',
      story2: 'We are not a general-purpose AI company — we are specialists who take one domain to its limit: translating arcane international rules into auditable engines, turning hundred-page contracts into living obligation timelines, all while upholding a privacy-first architecture: LC Shield does not save uploaded documents to our servers after analysis, and Vowpace stores only redacted contract text. Based in Hong Kong, we publish this site in three languages; our products\' language support is listed on each product page.',
      vision_label: 'Vision',
      vision: 'To be the contract-risk intelligence partner enterprises trust most — every contract fully understood before signing.',
      mission_label: 'Mission',
      mission: 'To reduce contract and document risk for construction and trade finance through rule-grade engines and privacy-first architecture.',
      values_label: 'Core Values',
      value_user: 'Domain Depth',
      value_innovation: 'Rule-Grade Precision',
      value_excellence: 'Privacy-First',
      value_collaboration: 'Global Outlook',
      eco_caption: 'DZent Flagship Platforms',
      eco_vowpace_tag: 'B2B Construction AI',
      eco_lc_tag: 'B2B Trade Finance',
      eco_miprose_tag: 'B2C Lifestyle Web',
      eco_coach_tag: 'B2C Mobile App',
      metrics_label: 'Enterprise Key Metrics',
      metric_products: 'Flagship Enterprise Platforms',
      metric_privacy: 'Encrypted in Transit (HTTPS)',
      metric_langs: 'LC Shield pre-check (typically under 30s)',
      metric_global_value: 'Cross-Border',
      metric_global: 'Compliance & Reach',
      bento1_t: 'Enterprise Contract & Compliance Engine',
      bento1_d: 'One engine that understands both construction contracts and trade documents: clause-by-clause parsing, cross-checked against UCP 600 / ISBP 821 (2023) rules and US subcontract clause patterns, delivering auditable risk reports.',
      bento1_scan: 'Scanning clauses',
      bento2_t: 'Privacy-First Architecture',
      bento2_d: 'LC Shield: uploaded documents are processed in memory and are not saved to our servers after analysis. Vowpace stores redacted contract text for the life of your account — encrypted in transit (HTTPS).',
      bento3_t: 'Pre-Signature Clause-Risk Review',
      bento3_d: 'Vowpace flags liquidated damages, indemnity and pay-when-paid clauses in US subcontracts before you sign — each finding cites the clause it comes from.',
      terminal_label: 'Trust & Compliance Terminal',
      terminal_note: 'Every audit runs live against industry rule libraries. LC Shield: uploaded documents are not saved to our servers after analysis; Vowpace: redacted contract text is stored for the life of your account.',
      expertise_label: 'What We Do Best',
      exp1_title: 'Contract Risk Scanning',
      exp1_desc: 'Liquidated damages, indemnity and pay-if-paid clauses flagged in US subcontracts.',
      exp2_title: 'Compliance Intelligence',
      exp2_desc: 'Translating arcane industry rules like UCP 600 and ISBP 821 (2023) into AI audit engines that run in real time.',
      exp3_title: 'Privacy-First Architecture',
      exp3_desc: 'LC Shield: uploaded documents are not saved to our servers after analysis. Vowpace stores redacted contract text for the life of your account.',
      exp4_title: 'US Subcontract Review',
      exp4_desc: 'Flagging high-risk clauses in US subcontracts before signature — liquidated damages, indemnities, and payment conditions.',
      timeline_label: 'Our Journey',
      tl1_year: '2026',
      tl1_title: 'Founded in Hong Kong',
      tl1_desc: 'DZent Limited is officially founded in Hong Kong, establishing our vertical focus — contract risk scanning and management — and launching our dual flagship platforms: construction contract risk engine Vowpace AI and LC pre-audit engine LC Shield.',
      tl2_year: 'H2 2026',
      tl2_title: 'Enterprise Expansion',
      tl2_desc: 'Scaling across B2B compliance and financial AI markets, deepening cross-border trade and construction contract risk solutions, and onboarding more enterprise clients.',
      tl3_year: 'Next',
      tl3_title: 'Future Vision',
      tl3_desc: 'Continuously deepening our contract intelligence and compliance audit technology, bringing this Hong Kong AI studio\'s expertise to more markets.',
      cta_title: 'Ready to safeguard every contract your business signs?',
      cta_desc: 'Enterprise partnerships, platform demos, or media requests — we\'d love to hear from you.',
      cta_btn: 'Contact Us',
    },
    products: {
      title: 'Flagship Platforms',
      subtitle: 'Two enterprise engines dedicated to contract risk scanning and management',
      learn_more: 'Learn More',
      launch_app: 'Launch App',
      coming_soon: 'Coming Soon',
      coming_soon_desc: 'More exciting products are in development. Stay tuned.',
      mp_name: 'MiProse',
      mp_desc: 'A letter to your future self — a 90-to-365-day time capsule web experience, delivered back to your inbox at midnight.',
      vw_tagline: 'Pre-signature subcontract clause-risk review for US commercial subcontractors',
      vw_desc: 'Pre-signature subcontract clause-risk review for US commercial subcontractors — automatically flags hidden liquidated damages, broad-form indemnities, and pay-when-paid clauses.',
      lc_tagline: 'AI-Powered UCP 600 & MT700 Discrepancy Assistant',
      lc_desc: "Pre-checks your letter-of-credit presentation against UCP 600 and ISBP 821 (2023) in typically under 30 seconds, so you can catch likely discrepancies before you present to the bank.",
      visit_site: 'Visit Website',
      explore: 'Explore',
      lc_cta: 'Visit getlcshield.com',
    },
    product_detail: {
      download: 'Download App',
      download_ios: 'App Store',
      download_android: 'Google Play',
      coming_soon_badge: 'Coming Soon',
      features_title: 'Core Features',
      screenshots_title: 'App Screenshots',
      design_title: 'Design Philosophy',
      download_title: 'Download Now',
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'Have questions or partnership inquiries? Feel free to reach out.',
      name: 'Name',
      name_placeholder: 'Enter your name',
      email: 'Email',
      email_placeholder: 'Enter your email',
      message: 'Message',
      message_placeholder: 'Enter your message',
      submit: 'Send',
      sending: 'Sending...',
      success: 'Thank you for your message! We will get back to you soon.',
      error: 'Failed to send. Please try again later.',
      email_label: 'Company Email',
      validation_name: 'Please enter your name',
      validation_email: 'Please enter a valid email',
      validation_message: 'Please enter a message',
      company_label: 'Company Information',
      company_name: 'DZent Limited (埵智有限公司)',
      company_registered: 'A limited company incorporated in Hong Kong',
    },
    footer: {
      copyright: '© 2026 DZent Limited. All rights reserved.',
      email: 'info@dzentlimited.com',
      follow_us: 'Follow Us',
      company_name: 'DZent Limited (埵智有限公司)',
      registered: 'A limited company incorporated in Hong Kong',
      legal_label: 'Legal',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
    },
  },
};
